module.exports = Jsw.skinUrl + "/images/sticker-collection/sticker/delorean.png?ddb1eb0796cbe5c96ad7eb3443ba4869";